<div class="flex flex-col gap-4">
  <div class="flex gap-4">
    <div>
      <pr-clinical-chart class="small-text hide-tooth-labels" />
    </div>

    <form class="flex flex-col" [formGroup]="form">
      @for (surface of selectableSurfaces$ | async; track surface) {
        <mat-checkbox color="primary" [formControlName]="surface">
          {{ surface | splitCamel | titlecase }}
        </mat-checkbox>
      }
    </form>
  </div>
  @if (isUnscoped$ | async) {
    <div class="flex items-center gap-2">
      <mat-icon>info</mat-icon>
      <span>
        When charted, this item will be 'unscoped' and will not be associated
        with any surface
      </span>
    </div>
  }
</div>
